import { useMemo } from "react";
import AdminLayout from "../../components/layouts/AdminLayout";
import HumanResourceLayout from "../../components/layouts/HumanResourceLayout";
import PayrollCompanyLayout from "../../components/layouts/PayrollCompanyLayout";
import SelfserviceLayout from "../../components/layouts/SelfserviceLayout";
import useUserStore from "../../state-management/useUserStore";

export enum ErrorPageType {
    NOT_FOUND = "NOT_FOUND",
    FORBIDDEN = "FORBIDDEN",
    PAGE_ERROR = "PAGE_ERROR",
}

type ErrorPageProps = {
    errorType: ErrorPageType;
    errorMessage?: string;
}

const ErrorPage = ({ errorType, errorMessage}: ErrorPageProps) => {
	const { userType } = useUserStore();
	const LAYOUT = useMemo(() => {
		switch(userType) {
			case "ORGANIZATION": 
				return PayrollCompanyLayout;
			case "ADMIN": 
				return AdminLayout;
			case "HR": 
				return HumanResourceLayout;
			default:
				return SelfserviceLayout;
		}
	}, [userType])

    return (
        <LAYOUT pageHeader="">
            <div className="grow flex justify-center items-center text-center">
                <div className="-translate-y-1/2">
                    <h1 className="text-9xl max-md:text-5xl font-bold">404</h1>
                    {errorMessage ? (
                        <p>{errorMessage}</p>
                    ):(
                        <p>
                            {errorType === ErrorPageType.FORBIDDEN 
                                ? "ACCESS DENIED! You can only access the pages outlined on the dashboard."
                                : errorType === ErrorPageType.NOT_FOUND
                                    ? "ERROR! The page you are looking for does not exist." 
                                    : "ACCESS DENIED! You do not have permission to access this page."
                            } 
                        </p>
                    )}
                </div>
            </div>
        </LAYOUT>
    );
}
 
export default ErrorPage;